import { render, staticRenderFns } from "./bpJob.vue?vue&type=template&id=6b4f5d2f&scoped=true&"
import script from "./bpJob.vue?vue&type=script&lang=js&"
export * from "./bpJob.vue?vue&type=script&lang=js&"
import style0 from "./bpJob.vue?vue&type=style&index=0&id=6b4f5d2f&prod&lang=scss&scoped=true&"
import style1 from "./bpJob.vue?vue&type=style&index=1&id=6b4f5d2f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f5d2f",
  null
  
)

export default component.exports